export { default } from './Collapsible';
